// extracted by mini-css-extract-plugin
export default {"card":"styles_blocks__card___ad","grid":"styles_blocks__grid___b2","simple-box":"styles_blocks__simple-box___c3"};